
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pensionstjek",
      function () {
        return require("private-next-pages/pensionstjek/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pensionstjek"])
      });
    }
  